import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { installOfflineLayer } from "@/offline/offlineManager";

// Offline layer (cache GET + file d'attente des écritures) — must be installed before first render
installOfflineLayer();

// Register Service Worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js', { updateViaCache: 'none' })
      .then((registration) => {
        console.log('MAAG PWA: Service Worker enregistré', registration.scope);
      })
      .catch((error) => {
        console.log('MAAG PWA: Erreur Service Worker', error);
      });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
